import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmContractsPage = styled('div')`
  .flex-center {
    display: flex;
    justify-content: center;
  }

  .actions {
    min-width: 210px;
    display: flex;
    gap: 15px;
    border: none !important;
    justify-content: right;
    .ant-btn {
      .text {
        color: ${(props) => props.theme.white} !important;
        border: none;
      }
    }
  }

  .ant-table-content {
    min-height: 900px;
  }

  .ant-form-item-control-input-content {
    max-width: 90%;
  }

  .ant-form-item {
    margin: 0;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-form-item-control-input {
      display: flex;
      justify-content: flex-end;
      .ant-form-item-control-input-content {
        max-width: 100%;
      }
    }
  }
`;

export const StyledFarmContractsPageContent = styled('div')`
  @media only screen and (max-width: ${breakpoints.lg}px) {
    height: -webkit-fill-available;
    .ant-tabs-nav::before {
      display: none;
    }
    .ant-tabs-nav {
      margin: 16px 0 16px 0;
      .ant-tabs-nav-wrap {
        display: none;
      }
    }
  }
`;
